import React, { memo, useEffect, useState } from 'react';
import { Checkbox } from '@atlaskit/checkbox';
import DropdownMenu, { DropdownItemGroupCheckbox } from '@atlaskit/dropdown-menu';
import PreferencesIcon from '@atlaskit/icon/glyph/preferences';
import { HeadCell } from '../../dynamic-result-table/src/dynamic-result-table';
import DownArrowIcon from '@atlaskit/icon/glyph/chevron-down';
import './customize-view.scss';

interface CustomizeViewProps {
  columns: Array<HeadCell>; // isMandatory and isChecked fields under headcell is not required if columns are static and cant be hidden any time .
  columnCount?: number; // maximum number of columns which can be rendered.
  updatedColumnView?: (columns: Array<HeadCell>) => void; // method to change the columns which are rendered by parent component
}

// eslint-disable-next-line react/display-name
const CustomizeView: React.FC<CustomizeViewProps> = memo(
  ({ columns, columnCount = 6, updatedColumnView }: CustomizeViewProps) => {
    const [columnsList, setColumnsList] = useState<Array<HeadCell>>(columns);

    useEffect(() => {
      setColumnsList(columns);
    }, [columns]);

    const checkedCount = () => {
      const updatedColumnView: Array<HeadCell> = [...columns];
      const count = updatedColumnView.reduce((acc, column) => {
        if (column.isChecked) {
          ++acc;
        }
        return acc;
      }, 0);
      if (count >= columnCount) return false;
      return true;
    };

    const updateColumnView = (columnDetail: HeadCell) => {
      const newColumnView: Array<HeadCell> = [...columns].map((column) => {
        if (columnDetail.content === column.content) {
          column.isChecked = !columnDetail.isChecked;
          return column;
        } else {
          return column;
        }
      });
      setColumnsList(newColumnView);
      updatedColumnView && updatedColumnView(newColumnView);
    };

    return (
      <div className="customize-view-container">
        <DropdownMenu
          position="bottom right"
          trigger="Customize view"
          triggerType="button"
          testId="customize-view-button"
          triggerButtonProps={{
            iconBefore: <PreferencesIcon label="Filter" />,
            iconAfter: <DownArrowIcon label="Filter" />,
            className: 'trigger-button',
            style: {
              marginLeft: '4px',
            },
            role: 'menu',
          }}
        >
          <DropdownItemGroupCheckbox id="actions">
            {columnsList.map((column) => {
              return column.isMandatory || !Object.prototype.hasOwnProperty.call(column, 'isMandatory') ? (
                <Checkbox
                  key={column.content as string}
                  value={column.content as string}
                  label={column.content as string}
                  testId={column.content as string}
                  isChecked={true}
                  isDisabled
                />
              ) : (
                <Checkbox
                  key={column.content as string}
                  value={column.content as string}
                  label={column.content as string}
                  testId={column.content as string}
                  isChecked={column.isChecked}
                  onChange={(e) => {
                    if (!column.isChecked && !checkedCount()) {
                      e.preventDefault();
                      return;
                    }
                    updateColumnView(column);
                  }}
                />
              );
            })}
          </DropdownItemGroupCheckbox>
        </DropdownMenu>
      </div>
    );
  }
);
export default CustomizeView;
